import {useState} from 'react';
import {uniqueId} from '@src/helpers/uniqueId';

export default function useUniqueId() {
    const [id] = useState(uniqueId());

    return id;
}
